import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { CYAN, YELLOW } from '../../HOME/const';
import * as f from '../logic';

class Scoreboard extends Component {
  render() {
    const { plays, aveScore, bestScore } = this.props.stats || {};
    const { steps, score, level, timeLeft } = this.props;
    const levelInfo = f.levelInfo(level || 1);
    const color = levelInfo.color;

    return (
      <div className="tt-scoreboard">
        <span style={{ gridArea: '1/1', color: YELLOW }}>{plays || 0}</span>
        <span style={{ gridArea: '2/1', marginTop: '-1px' }}>plays</span>
        <span style={{ gridArea: '1/2', color: CYAN }}>{aveScore || 0}</span>
        <span style={{ gridArea: '2/2', marginTop: '-1px' }}>ave. score</span>
        <span style={{ gridArea: '1/3', color: CYAN }}>{bestScore || 0}</span>
        <span style={{ gridArea: '2/3', marginTop: '-1px' }}>best score</span>
        <span className="tt-quartz" style={{ gridArea: '3/1', color: YELLOW }}>
          {steps || 0}
        </span>
        <span className="tt-score-label" style={{ gridArea: '4/1' }}>
          triominos
        </span>
        {(level || 1) < 2 ? null : (
          <span className="tt-quartz" style={{ color }}>
            {`0:${timeLeft < 10 ? '0' : ''}${timeLeft}`}
          </span>
        )}
        <span className="tt-quartz" style={{ gridArea: '3/3', color: CYAN }}>
          {score || 0}
        </span>
        <span className="tt-score-label" style={{ gridArea: '4/3' }}>
          score
        </span>
      </div>
    );
  }
}

function mapStateToProps({ tm, common }) {
  return { ...tm, ...common };
}

export default connect(
  mapStateToProps,
  {},
  null,
  { forwardRef: true }
)(Scoreboard);
